<app-bulk-upload (showBulk)="displayBulk($event)" *ngIf="showBulk2"></app-bulk-upload>

<header *ngIf="isAuthenticated() && topService.isDone" class="header" [class.zindex]="showAdminNav">
  <div class="header-inner" [class.search-active]="topService.isSearchActive" (clickOutside)="hideSearch()"
    [class.show-categories]="topService.trendingNavVisible"
    [class.single-outlet]="outletService.isManufacturerOutlet()">
    <div class="header-logo" [ngClass]="{'logo-padding': topService.trendingNavVisible}">
      <a class="header-logo__link" (click)="clickLogoToReload()">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px" y="0px" width="91px" height="28px" viewBox="0 0 124 32" enable-background="new 0 0 121 32"
          xml:space="preserve">
          <path class="rotate-this" fill="#F15B5D"
            d="M119.143,22.692c-1.205-1.204-2.835-1.696-4.406-1.522c0.126-0.014,0.25-0.024,0.376-0.029
                c-1.127-0.118-2.225-0.626-3.089-1.49c-0.877-0.877-1.391-1.988-1.497-3.136c-0.005,0.16-0.018,0.319-0.037,0.479
                c0.194-1.591-0.296-3.249-1.517-4.47c-0.915-0.915-2.085-1.432-3.283-1.546c-0.005-0.004-0.009-0.008-0.014-0.004
                c-0.25,0.013-0.491,0.009-0.732-0.021c-1.127-0.119-2.225-0.606-3.089-1.47c-0.878-0.877-1.369-1.987-1.475-3.136
                c-0.005-0.013-0.005-0.021,0-0.034c-0.021-0.191-0.03-0.395-0.021-0.598c-0.098-1.225-0.618-2.424-1.555-3.36
                c-2.106-2.106-5.521-2.105-7.627,0c-2.106,2.106-2.106,5.521,0,7.627c0.911,0.911,2.076,1.432,3.263,1.55
                c0.013-0.004,0.025,0,0.033,0c0.25,0.03,0.5,0.034,0.75,0.021h0.025c1.114,0.123,2.208,0.614,3.063,1.47
                c0.848,0.848,1.335,1.919,1.462,3.03c-0.013,0.284-0.008,0.568,0.03,0.843c-0.009,0.008-0.005,0.013-0.005,0.021
                c0.127,1.178,0.645,2.331,1.547,3.233c1.225,1.225,2.891,1.715,4.485,1.515c-0.139,0.018-0.269,0.029-0.407,0.036
                c1.114,0.123,2.201,0.636,3.058,1.491c0.847,0.848,1.355,1.92,1.482,3.029c0.008-0.139,0.021-0.275,0.039-0.414
                c-0.209,1.603,0.28,3.28,1.513,4.512c2.105,2.106,5.521,2.106,7.627,0C121.248,28.213,121.248,24.799,119.143,22.692" />
          <path class="rotate-this" fill="#F15B5D" d="M91.177,22.692c2.105-2.106,5.521-2.106,7.627,0c2.105,2.106,2.105,5.521,0,7.627
                c-2.106,2.106-5.521,2.106-7.627,0C89.07,28.213,89.07,24.799,91.177,22.692" />
          <path class="rotate-this" fill="#F15B5D" d="M111.516,2.354c2.105-2.106,5.521-2.106,7.627,0c2.105,2.106,2.105,5.521,0,7.627
                c-2.106,2.106-5.521,2.106-7.627,0C109.409,7.875,109.409,4.46,111.516,2.354" />
          <path fill="#fff" d="M18.63,7.601H7.266v-7.702H0.279v32h6.987V14.589h10.647v17.311H24.9V13.872
                C24.9,10.472,22.029,7.601,18.63,7.601" />
          <path fill="#fff" d="M47.687,7.601v17.311H37.038V7.601h-6.987v18.027c0,3.458,2.813,6.271,6.271,6.271h12.08
                c3.458,0,6.271-2.813,6.271-6.271V7.601H47.687z" />
          <path fill="#fff" d="M78.175,7.601H66.811v-7.702h-6.987v32h18.351c3.458,0,6.271-2.813,6.271-6.271V13.872
                C84.446,10.414,81.633,7.601,78.175,7.601 M66.811,14.589H77.46v10.323H66.811V14.589z" />
        </svg>
      </a>
    </div>
    <div class="header-menu _left-menu" [class.hide]="topService.hideMenusOnError">
      <ul class="header-menu-list">
        <!-- Categories menu -->
        <li class="categories-menu">
          <a [class.disabled]="topService.loading" (click)="toggleCategories(true)">
            <i class="_icon">
              <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="m5.63073076 9.69375c1.22102099.12285 2.1424133 1.1331 2.1424133 2.349675 0 1.1169-.80181364 2.090025-1.90643866 2.314125-.15686176.032175-.31849756.048375-.48013337.048375s-.32327162-.0162-.48036071-.048375c-1.10462502-.2241-1.90621132-1.19745-1.90621132-2.3139 0-1.216575.92139231-2.22705 2.14332264-2.3499.15868044-.01665.32668165-.01665.48740812 0zm-.24415873-6.69375c1.31604738 0 2.38657203 1.059525 2.38657203 2.361825 0 1.30275-1.07052465 2.3625-2.38657203 2.3625-1.31604739 0-2.38657203-1.05975-2.38657203-2.3625 0-1.3023 1.07052464-2.361825 2.38657203-2.361825zm0 13.2759c1.31604738 0 2.38657203 1.05975 2.38657203 2.36205s-1.07052465 2.36205-2.38657203 2.36205c-1.31604739 0-2.38657203-1.05975-2.38657203-2.36205s1.07052464-2.36205 2.38657203-2.36205zm6.85758667-6.58215c1.2207937.12285 2.1424133 1.1331 2.1424133 2.349675 0 1.1169-.8018136 2.090025-1.9064386 2.314125-.1568618.032175-.3184976.048375-.4801334.048375s-.3232716-.0162-.4803607-.048375c-1.1043977-.2241-1.90621133-1.19745-1.90621133-2.3139 0-1.216575.92139233-2.22705 2.14332263-2.3499.1586805-.01665.3266817-.01665.4874081 0zm-.2441587-6.69375c1.3158201 0 2.386572 1.059525 2.386572 2.361825 0 1.30275-1.0707519 2.3625-2.386572 2.3625-1.3160474 0-2.38657203-1.05975-2.38657203-2.3625 0-1.3023 1.07052463-2.361825 2.38657203-2.361825zm0 13.2759c1.3158201 0 2.386572 1.05975 2.386572 2.36205s-1.0707519 2.36205-2.386572 2.36205c-1.3160474 0-2.38657203-1.05975-2.38657203-2.36205s1.07052463-2.36205 2.38657203-2.36205zm6.8575867-6.58215c1.221021.12285 2.1424133 1.1331 2.142186 2.349675 0 1.1169-.8018137 2.090025-1.9062114 2.314125-.1568617.032175-.3187249.048375-.4803607.048375s-.3234989-.0162-.4803607-.048375c-1.104625-.2241-1.9062113-1.19745-1.9062113-2.3139 0-1.216575.9216197-2.22705 2.14355-2.3499.1579984-.016425.3273636-.016425.4874081 0zm-.2441587-1.969425c-1.3158201 0-2.3865721-1.05975-2.3865721-2.3625 0-1.3023 1.070752-2.361825 2.3865721-2.361825 1.31582 0 2.386572 1.059525 2.386572 2.361825 0 1.30275-1.070752 2.3625-2.386572 2.3625zm0 8.551575c1.31582 0 2.386572 1.05975 2.386572 2.36205s-1.070752 2.36205-2.386572 2.36205c-1.3158201 0-2.3865721-1.05975-2.3865721-2.36205s1.070752-2.36205 2.3865721-2.36205z"
                  fill="#FFFFFF" fill-rule="evenodd" stroke="none" stroke-width="1"></path>
              </svg>
            </i>
            <span class="categories-span">Categories</span>
          </a>
        </li>

        <li>
          <a (click)="clickLogoToReload()" [class.disabled]="topService.loading">
            <i class="_icon">
              <img src="assets/images/icons/header/home-white.svg" width="24" height="24" alt="Home">
            </i>
            <span class="home-label">Home</span>
          </a>
        </li>
        <li (click)="outlets()">
          <a [class.disabled]="topService.loading">
            <i class="_icon">
              <img src="assets/images/icons/header/outlets-white.svg" width="24" height="24" alt="Outlets">
            </i>
            <span>Outlets</span>
          </a>
        </li>
        <!-- Past Purchases -->
        <li *ngIf="showPastPurchase()">
          <a [routerLink]="['buyer/past_purchases']" routerLinkActive="active" [class.disabled]="topService.loading">
            <i class="_icon">
              <img src="assets/images/icons/header/past-purchase-white.svg" width="24" height="24" alt="Past Purchase">
            </i>
            <span class="past-purchase-label">Past Purchase</span>
          </a>
        </li>
        <li>
          <a [class.disabled]="topService.loading || topService.isExporting" (click)="getPriceList()">
            <i class="_icon">
              <img *ngIf="!topService.isExporting" src="assets/images/icons/header/price-list-white.svg" width="24"
                height="24" alt="Price List">
              <i *ngIf="topService.isExporting" class="loader"></i>
            </i>
            <span class="price-label">Price List</span>
          </a>
        </li>
        <!-- Notifications center -->
        <li *ngIf="user_role === 'BUYER' || user_role === 'SUPER' || user_role === 'SALES'" class="notif-bell">
          <a [routerLink]="['notifications']" routerLinkActive="active" [class.disabled]="topService.loading">
            <i class="_icon">
              <img src="assets/images/icons/rebranding/header-bell.svg" width="24" height="24" alt="Notification">
            </i>
            <span class="_badge-notification" *ngIf="newNotificationCounter > 0">{{newNotificationCounter}}</span>
            <span class="notif-label">Notifications</span>
          </a>
        </li>

        <!-- Offer Notifications -->
        <li *ngIf="user_role === 'BUYER' || user_role === 'SUPER' || user_role === 'SALES'">
          <a [class.disabled]="topService.loading" (click)="offersService.showOffersDisabledMessage()">
            <i class="_icon">
              <img src="assets/images/icons/rebranding/offers-header.svg" width="24" height="24"
                alt="Offer Notifications">
            </i>
            <span class="_badge-offer" *ngIf="offersService.offersSummary?.unseenEventCount > 0">
              {{offersService.offersSummary?.unseenEventCount}}
            </span>
            <span class="notif-label __offers">My Offers</span>
          </a>
        </li>

        <li [ngClass]="{'margin-adjust': topService.trendingNavVisible}"
          *ngIf="user_role === 'BUYER' || user_role === 'GUEST' || user_role === 'SUPER' || user_role === 'SALES'">
          <a [routerLink]="['auctions']" routerLinkActive="active" [class.disabled]="topService.loading">
            <i class="_icon __auctions">
              <svg *ngIf="auctionService.itemsReady && auctionService.liveAuctionCounter>0" class="icon-glow"
                height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" fill-rule="evenodd" fill="#B4F397" r="5" />
              </svg>
              <svg [ngClass]="{'_green-dot': auctionService.itemsReady && auctionService.liveAuctionCounter>0,
              '_red-dot': auctionService.itemsReady && auctionService.liveAuctionCounter<1}" height="24"
                viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" fill-rule="evenodd" r="5" />
              </svg>
            </i>
            <span class="auctions-span">Live Auctions</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="header-menu _right-menu" [class.hide]="topService.hideMenusOnError">
      <ul class="header-menu-list">
        <li *ngIf="!sharedService.isLogoutPage">
          <a (click)="showSearch()">
            <i class="_icon">
              <img src="assets/images/icons/header/search-white.svg" width="32" height="32" alt="Search">
            </i>
          </a>
        </li>
        <!-- Bulk Upload -->
        <li *ngIf="user_role === 'BUYER'">
          <a title="SKU Upload" (click)="displayBulk(true)" [class.disabled]="topService.loading">
            <i class="_icon bulk-upload">
              <img src="assets/images/icons/header/upload-skus-white.svg" width="32" height="32" alt="SKU Upload">
            </i>
          </a>
        </li>
        <li>
          <a (click)="gotoCart()">
            <i class="_icon">
              <img src="assets/images/icons/header/cart-white.svg" width="32" height="32" alt="Cart">
            </i>
            <span *ngIf="cartService.cartList && cartService.cartList.length > 0" class="cart-counter"
              [class.jump]="cartService.isShownAddedModal">{{ cartService.totalUnits() }}</span>
          </a>
        </li>
        <li>
          <a [routerLink]="['/user/orders']" title="My Account">
            <i class="_icon">
              <img src="assets/images/icons/header/account-white.svg" width="32" height="32" alt="My Account">
            </i>
          </a>
        </li>
        <li *ngIf="this.user_role === 'SALES' || this.user_role === 'SUPER'" class="customer-select"
          (click)="showAdminNav = !showAdminNav">
          <a (click)="onActivateBulkUpload()">
            <span *ngIf="userService.currentCustomer">{{getCurrentCustomer()}}</span>
            <i class="_icon _customer" [class._animated]="customersLoading">
              <svg class="dots" width="24px" height="24px" viewBox="0 0 24 24" version="1.1"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="dots" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <path
                    d="M12,7 C10.3431458,7 9,5.65685425 9,4 C9,2.34314575 10.3431458,1 12,1 C13.6568542,1 15,2.34314575 15,4 C15,5.65685425 13.6568542,7 12,7 Z"
                    id="Path-1" fill="#FFFFFF"></path>
                  <path
                    d="M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z"
                    id="Path-2" fill="#FFFFFF"></path>
                  <path
                    d="M12,23 C10.3431458,23 9,21.6568542 9,20 C9,18.3431458 10.3431458,17 12,17 C13.6568542,17 15,18.3431458 15,20 C15,21.6568542 13.6568542,23 12,23 Z"
                    id="Path-3" fill="#FFFFFF"></path>
                </g>
              </svg>
            </i>
          </a>
        </li>

        <form [hidden]="hideAdminMenu">
          <div *ngIf="showAdminNav && salesCustomers && salesCustomers.customers.length" class="admin-nav"
            (clickOutside)="hideAdminNav($event)" [clickOutsideExclude]="'.customer-select'">
            <div class="admin-nav-row">
              <div class="admin-nav-col __company">
                <label class="admin-nav-checkbox" *ngIf="user_role==='SUPER'">
                  <span class="admin-nav-checkbox__label">All</span>
                  <input type="checkbox" [(ngModel)]="userService.canSeeAllCustomers"
                    (click)="showAllCustomersChoosen($event)" name="all" id="all" value="all">
                  <i class="admin-nav-checkbox__icon"></i>
                </label>
              </div>
              <div class="admin-nav-col __select" [class.max-width]="showBulk">
                <!-- <select2 name="customer" id="customer" value="" (valueChanged)="chooseCustomer($event)"
                  [disabled]="topService.loading" >
                  <option *ngFor="let customer of salesCustomers.customers" [ngValue]="customer['bpCode']">{{customer['bpCode']}} - {{customer['companyName']}}
                  </option>
                </select2> -->

                <app-dropdown [items]="salesCustomers.customers" [disabled]="topService.loading"
                  [fieldToShow]="'bpCodeAndCompanyName'" [fieldToSave]="'bpCode'" [enableFilter]="true"
                  [isFromBuyerPortal]="true" [(ngModel)]="selectedBpCode" (onSelect)="chooseCustomer($event)"
                  name="selectedBpCode">
                </app-dropdown>


              </div>
              <div class="admin-nav-col __bulk">
                <button [ngClass]="{'hide': showBulk}" (click)="showBulk = !showBulk" class="b-upload">
                  <img src="assets/images/icons/rebranding/upload.svg" width="24px" height="24px" />
                </button>
                <button [ngClass]="{'hide': !showBulk, 'zoomIn': '!showBulk'}"
                  (click)="validateBulkUploadBeforeSubmit()" class="b-submit animated"
                  [disabled]="bulkUploadFieldData.length === 0">
                  <span *ngIf="!showLoad">Submit</span>
                  <div *ngIf="showLoad" class="bulk-loader"></div>
                </button>
              </div>
            </div>
            <div *ngIf="showBulk" class="admin-nav-row">
              <textarea (keyup)="checkBulkDataLength()" (change)="excelData=$event.target.value" id="excel_data"
                [ngClass]="{'zoomIn': showBulk}" class="bulk-area animated" [(ngModel)]="bulkUploadFieldData"
                name="bulkUploadData" placeholder="">{{excelData}}</textarea>
            </div>
          </div>
        </form>
      </ul>
    </div>
    <div class="header-menu _search">
      <div class="search-box">
        <button [disabled]="isSearchEmpty() || !topSearch.value" (click)="searchItems(topSearch.value)"
          class="searchButton">
          <svg height="32" viewBox="0 0 32 32" width="32" xmlns="http://www.w3.org/2000/svg">
            <path
              d="m25.84375 22.8029159-4.4166667-4.4727935c.71875-1.2548816 1.09375-2.6503515 1.09375-4.0562354 0-4.56131215-3.7083333-8.273887-8.2604166-8.273887-4.55208337 0-8.2604167 3.71257485-8.2604167 8.273887 0 4.5613122 3.70833333 8.273887 8.2604167 8.273887 1.453125 0 2.890625-.4009372 4.171875-1.1663629l4.3958333 4.4571726c.0989583.0989326.2395833.1614163.3802083.1614163s.28125-.0572768.3802084-.1614163l2.2552083-2.2806561c.2083333-.213486.2083333-.5467326 0-.7550117zm-11.5833333-13.57979692c2.78125 0 5.0416666 2.26503512 5.0416666 5.05076802s-2.2604166 5.050768-5.0416666 5.050768-5.0416667-2.2650351-5.0416667-5.050768 2.2604167-5.05076802 5.0416667-5.05076802z"
              fill="#fff" />
          </svg>
        </button>
        <input [disabled]='searchDisabled()' #topSearch type="text" class="searchTerm" placeholder="Search"
          [ngModel]="topService.searchString" (keyup)="isKeyEnter($event, topSearch.value)">
        <div class="search-close" title="Close search" (click)="hideSearch()">
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="delete/white" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <polygon id="Shape" fill="#FFFFFF" fill-rule="nonzero"
                points="19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12">
              </polygon>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>

</header>

<!-- END OF HEADER -->
<div>
  <app-top-categories></app-top-categories>
</div>

<!-- Add To Cart Dialog -->
<app-add-to-cart-modal *ngIf="cartService.isShownAddedModal"
  [shortAnimation]="this.user_role === 'SALES' || this.user_role === 'SUPER'"></app-add-to-cart-modal>

<!-- Delete Cart Dialog -->
<app-confirm-modal *ngIf="showDelCart" [message]="clearCartMsg"
  (confirmed)="$event ? uploadContent() : onCloseDelCart()"></app-confirm-modal>

<!-- Bulk Upload Result Modal Dialog -->
<div *ngIf="showBulkErr || bulkUploadInProgress !== false" class="edit-confirm bulk-warning">
  <div class="add-to-wrap animated" [class.zoomIn]="showBulkErr">
    <div class="message">
      <ul>
        <li *ngIf="bulkUploadInProgress">
          <div class="loader"></div> {{ showloadString }}
        </li>
        <li *ngFor="let messages of bulkapi_response">{{messages.message}}</li>
      </ul>
    </div>

    <div class="bottom-controls">
      <button type="button" class="bottom-controls__cancel" [disabled]="bulkUploadInProgress"
        (click)="showBulkErr = !showBulkErr;hideAdminMenu=true;">Cancel</button>
      <button type="button" class="bottom-controls__continue" [disabled]="bulkUploadInProgress || disabledClassApplied"
        (click)="continueLogicallyAfterButlAttempt();"
        [class.disabled]="bulkUploadInProgress || disabledClassApplied">Continue</button>
    </div>
  </div>
</div>

<div *ngIf="checkForSearchErr()" class="reset-pwd-modal search-err">
  <div class="add-to-wrap animated" [class.zoomIn]="searchAlert" [class.zoomOut]="animateOut">
    <div class="modal-content">
      <div class="modal-header">
        <button (click)="closeSearchErr()" type="button" class="close" aria-label="Close"></button>
        <div class="d-flex align-items-start">
          <div class="align-self-center title-icon">
            <img [src]="imageBaseUrl + '/assets/images/exclamation-mark.svg'"
              width="48" height="48" /></div>
          <div class="align-self-center modal-title">Error searching for order #{{ showErrTitle() }}</div>
        </div>
      </div>
      <div class="modal-body">
        <span>{{ showErrMessage() }}</span>
      </div>
      <div class="modal-footer">
        <button type="button" (click)="closeSearchErr()" class="btn btn-modal btn-modal-confirm">Got it</button>
      </div>
    </div>
  </div>
</div>

<app-user-filters-typeahead *ngIf="topService.isSearchActive"></app-user-filters-typeahead>

<app-error-modal [bodyText]="topErrorModal.bodyText" [title]="topErrorModal.title" [isError]="topErrorModal.isShown"
  (onConfirmError)="hideError()"></app-error-modal>

<app-dropdown-categories (close)="toggleCategories($event)" *ngIf="isCategoriesOpened"></app-dropdown-categories>

<app-confirmation-popup *ngIf="offersService.confirmationPopupSettings.show"
  [settings]="offersService.confirmationPopupSettings" >
</app-confirmation-popup>